/**
 * The Planning's window (OPS-1, 23 Oct): how many days it shows at once. One
 * number, read by the API's query, the app's address and its select, so the
 * three can never disagree. 92 days is a quarter: a usability and load cap
 * (a day is 64 px at least, so 92 days are a 5,900 px region, scrolled
 * sideways), not a limit of the data. Raising it is this number and the
 * stylesheet's safelist of grid lines (apps/staff/src/styles.css).
 */
export const TIMELINE_MAX_DAYS = 92

/** The spans the select offers; any other number of days is typed ("Personalizzato"). */
export const TIMELINE_DAY_PRESETS = [3, 7, 14, 30, 60] as const

/** The window shown when the address names none and the device remembers none. */
export const TIMELINE_DEFAULT_DAYS = 7

/** Whether a value is a number of days the Planning may show: a whole number, 1 to the cap. */
export function isTimelineDays(value: unknown): value is number {
  return (
    typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= TIMELINE_MAX_DAYS
  )
}
